import React, { useState, useEffect, useContext, useReducer } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Chip,
  Dialog,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import AddInterview from "./editinterview";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import {
  deleteuserstatus,
  getallShortlistFilter,
} from "../shortlisted/mutation";
import { fetchAll, deleteItem, postItem, fetchById, FetchDataGet } from "../../../BaseUrl";
import { getallFilterinterview, getallinterview, searchInterview } from "./mutation";
import MessagePopup from "../../Utils/MessagePopup";
import LoadingSpinner from "../../loader/loadercomp";
import { UserContext } from "../../usercontext/usercontext";
import OptionConvert from "../../Utils/OptionConvert";
import ExportDialog from "../../Utils/ExportDialog";
import {
  filterInitialState,
  filterReducer,
  handleChangeDispatch,
} from "../../Utils/FilterReducer";
import ReusableFilter from "../../Utils/ReusableFilter";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import colors from "../../../assest/theme/base/colors";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { GETCLIENT } from "../../Masters/ClientMaster/Mutation";
import {
  Getalluserdetail,
  GetalluserdetailDropdown,
  getByTLUserdetail,
} from "../../Masters/UserMaster/mutation";
import MaterialInput from "../../../components/MaterialInput";
import {GETCLIENTDROPDOWN} from '../../Masters/PositionMaster/mutation'

function Interview() {
  const { user, isuser } = useContext(UserContext);
  const [filterState, dispatch] = useReducer(filterReducer, filterInitialState);
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [view, setview] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [editeddata, setEditeddata] = useState([]);
  const [editedtrue, setEditedtrue] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => { },
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [userlist, setuserlist] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [fileterdownloadurl, setFileterdownloadurl] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isview, setisview] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const columns = [
    { label: "Interview Date", field: "interviewDate", width: "90px" },
    { label: "Name", field: "candidateName", width: "100px" },
    { label: "Contact Number", field: "candidateNumber", width: "90px" },
    { label: "Client", field: "clientName", width: "100px" },
    { label: "Position", field: "positionName", width: "100px" },
    { label: "HR Name", field: "createdBy", width: "120px" },
    { label: "Status", field: "status", width: "90px" },
    { label: "Feedback", field: "interviewFeedback", width: "100px" },
    { label: "Actions", field: "actions", width: "100px" },
  ];

  const validIndustryData = Array.isArray(userlist) ? userlist : [];

  const sortedData = [...validIndustryData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validIndustryData; // default to descending
    }
  });

  const exportData = sortedData.map((item) => ({
    interviewDate: item.interviewDate ? item.interviewDate : item.interviewDate,
    candidateName: item.candidateName || "",
    contactNumber: item.candidateNumber || "",
    clientName: item.clientName || "",
    positionName: item.positionName || "",
    hrName: item.createdBy || "",
    status: item.status || "",
    interviewFeedback: item.interviewFeedback || "",
    createdAt: item.createdAt || "",
    updatedAt: item.updatedAt || "",
  }));

  const fetchCurrentData = () => {
    if (isFilter) {
      filterSubmit();
    } else {
      getInterviewData();
    }
  };

  useEffect(() => {
    getClientData();
    getUser();
  }, []);

  useEffect(() => {
    if (!open) {
      const delayDebounceFn = setTimeout(() => {
        fetchCurrentData();
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [page, pageSize, open, searchdata]);

  useEffect(() => {
    setPage(1);
  }, [searchdata]);

  const formClose = () => {
    setOpen(false);
    setview(false);
    setisview(false);
    setEditedtrue(false);
  };

  const handleResetFilter = () => {
    setIsFilter(false);
    dispatch({ name: "reset" });
    if (page === 1) {
      getInterviewData();
    } else {
      setPage(1);
    }
  };

  const filterClose = () => {
    setOpenFilter(false);
  };
  const onView = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
    setisview(true);
  };

  const onEdit = (id) => {
    let data = userlist.filter((x) => x.id === id);
    setEditeddata(data);
    setEditedtrue(true);
    setOpen(true);
    setview(true);
  };

  const deletelist = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete this records ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteconfirm(id),
      onClose: () => deletecancel(),
    });
  };

  const formatDate = (isoDate) => {
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
  };

  const deleteconfirm = async (id) => {
    try {
      const variables = {
        input: {
          id: id,
        },
      };
      const response = await deleteItem(deleteuserstatus, variables);
      if (response.deleteScreening.success === true) {
        setPopup({
          open: true,
          message: response.deleteScreening.message,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: response.deleteScreening.message,
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      deletecancel();
      fetchCurrentData();
    }
  };

  const deletecancel = () => {
    setDialogOpen(false);
    setDialogData({
      ...dialogData,
      title: "",
      content: "",
      onConfirm: () => { },
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const getInterviewData = async () => {
    setLoader(true);
    try {
      if (searchdata && searchdata.length > 2) {
          const payload = {
          search: searchdata,
          page,
          pageSize,
          ...(user.roleName !== "Admin" && {
            hrUserId: parseInt(isuser.userid),
          }),
        };
        const response = await FetchDataGet(searchInterview, payload);
        if (response?.searchInterviewCandidates?.success === true) {
          const RowsData = response?.searchInterviewCandidates?.screening?.map(
            (item) => ({
              id: item?.id,
              interviewDate: item?.interviewDate
                ? formatDate(item?.interviewDate)
                : "",
              candidateName: item?.candidateName || "",
              candidateNumber: item?.candidateNumber || "",
              status: item?.status || "",
              positionName: item?.position?.positionName || "",
              positionId: item?.position?.id || "",
              clientName: item?.client?.clientName || "",
              clientId: item?.client?.id || "",
              shortlistFeedback: item?.shortlistFeedback || "",
              interviewFeedback: item?.interviewFeedback || "",
              createdBy: item?.createdBy || "",
              createdAt: item?.createdAt || "",
              updatedAt: item?.updatedAt || "",
            })
          );
          setuserlist(RowsData);
          setTotalCount(response?.searchInterviewCandidates?.totalCount || 0);
        } else {
          setuserlist([]);
        }
      } else {
        if (user.roleName === "Admin") {
          const response = await FetchDataGet(getallinterview, { page, pageSize });
          if (response?.getAllInterviews?.success === true) {
            const RowsData = response?.getAllInterviews?.screening?.map(
              (item) => ({
                id: item?.id,
                interviewDate: item?.interviewDate
                  ? formatDate(item?.interviewDate)
                  : "",
                candidateName: item?.candidateName || "",
                candidateNumber: item?.candidateNumber || "",
                status: item?.status || "",
                positionName: item?.position?.positionName || "",
                positionId: item?.position?.id || "",
                clientName: item?.client?.clientName || "",
                clientId: item?.client.id || "",
                shortlistFeedback: item?.shortlistFeedback || "",
                interviewFeedback: item?.interviewFeedback || "",
                createdBy: item?.createdBy || "",
                createdAt: item?.createdAt || "",
                updatedAt: item?.updatedAt || "",
              })
            );
            setuserlist(RowsData);
            setTotalCount(response?.getAllInterviews?.totalCount || 0);
          } else {
            setuserlist([]);
          }
        } else {
          const variables = {
            hrUserId: isuser.userid,
            page,
            pageSize
          };
          const response = await postItem(getallFilterinterview, variables);
          if (response?.getAllInterviews?.success === true) {
            const RowsData = response?.getAllInterviews?.screening?.map(
              (item) => ({
                id: item?.id,
                interviewDate: item?.interviewDate
                  ? formatDate(item?.interviewDate)
                  : "",
                candidateName: item?.candidateName || "",
                candidateNumber: item?.candidateNumber || "",
                status: item?.status || "",
                positionName: item?.position?.positionName || "",
                positionId: item?.position?.id || "",
                clientName: item?.client?.clientName || "",
                clientId: item?.client.id || "",
                shortlistFeedback: item?.shortlistFeedback || "",
                interviewFeedback: item?.interviewFeedback || "",
                createdBy: item?.createdBy || "",
                createdAt: item?.createdAt || "",
                updatedAt: item?.updatedAt || "",
              })
            );
            setuserlist(RowsData);
            setTotalCount(response?.getAllInterviews?.totalCount || 0);
          } else {
            setuserlist([]);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsFilter(false);
      dispatch({ name: "reset" });
    }
  };

  const getUser = async () => {
    setLoader(true);
    const role = user?.roleName;
    const userId = parseInt(isuser?.userid);

    try {
      if ((role === "Team Lead" || role === "Team Leader") && userId) {
        const variables = { id: userId };

        const response = await fetchById(getByTLUserdetail, variables);
        if (response?.getTeamLeaderUserById?.success === true) {
          const data = response?.getTeamLeaderUserById.data;
          const userData = OptionConvert(data, "username", "id");
          setUserOptions(userData);
        } else {
          setuserlist([]);
        }
      } else {
         const variables = {
                search: '',
                page: 0,
                pageSize:0,
              };
        const response = await FetchDataGet(GetalluserdetailDropdown,variables);
        if (response?.getAllCustomUserDetails?.success === true) {
          const data = response?.getAllCustomUserDetails.data;
          const userData = OptionConvert(data, "username", "id");
          setUserOptions(userData);
        } else {
          setuserlist([]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getClientData = async () => {
    try {
      const variables = {
        search: '',
        page: 0,
        pageSize:0,
      };
      const response = await FetchDataGet(GETCLIENTDROPDOWN,variables);
      if (response?.getAllClients?.success === true) {
        const data = response?.getAllClients?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName, 
          address: v?.address,
          mapLocation: v?.mapLocation,
          contactperson: v?.primaryContactPerson,
        }));

        if (user?.roleName === "Admin" || user?.roleName === "Consultant") {
          setClientOptions(data);
        } else {
          const res = await FetchDataGet(GetalluserdetailDropdown,variables);
          if (res?.getAllCustomUserDetails?.success === true) {
            let filteredIsUsers = [];
            const userDetails = res.getAllCustomUserDetails.data;

            filteredIsUsers = userDetails.find(
              (item) => item.id === String(isuser.userid)
            );

            let client = filteredIsUsers.clientHandling.map(
              (value) => value.id
            );

            let filteredData = client.map((client) =>
              data.find((item) => item.value == client)
            );

            setClientOptions(filteredData);
          } else {
            setClientOptions([]);
          }
        }
      } else {
        setClientOptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const filterSubmit = async () => {
    debugger;
    setLoader(true);

    try {
      const isPrivileged = ["Admin"].includes(user?.roleName);

      const hrUserIds =
        filterState?.user?.length > 0
          ? filterState.user.map((u) => u?.value)
          : isPrivileged
            ? []
            : [parseInt(isuser?.userid)];

      const clientIds =
        filterState?.client.length > 0
          ? filterState?.client?.map((c) => c?.value)
          : [];
      const filters = {
        hrUserIds: hrUserIds,
        clientIds: clientIds,
        statusList: ["selected", "rejected", "hold", "interviewed"],
        dateFrom: filterState?.fromDate || null,
        dateTo: filterState?.toDate || null,
        interviewFromDate: filterState.interviewFromDate,
        interviewToDate: filterState.interviewToDate,

        onboardJoiningFromDate: filterState.onboardJoiningFromDate,
        onboardJoiningToDate: filterState.onboardJoiningToDate,
        onboardSrFromDate: filterState.onboardSrFromDate,
        onboardSrToDate: filterState.onboardSrToDate,
      };

      const response = await postItem(getallShortlistFilter, {
        filters,
        page,
        pageSize
      });
      if (response?.exportFilteredScreenings?.success === true) {
        setFileterdownloadurl(response?.exportFilteredScreenings?.downloadUrl)
        const RowsData = response?.exportFilteredScreenings?.screening?.map(
          (item) => ({
            id: item?.id,
            interviewDate: item?.interviewDate
              ? formatDate(item?.interviewDate)
              : "",
            candidateName: item?.candidateName || "",
            candidateNumber: item?.candidateNumber || "",
            status: item?.status || "",
            positionName: item?.position?.positionName || "",
            positionId: item?.position?.id || "",
            clientName: item?.client?.clientName || "",
            clientId: item?.client.id || "",
            shortlistFeedback: item?.shortlistFeedback || "",
            interviewFeedback: item?.interviewFeedback || "",
            createdBy: item?.createdBy || "",
            createdAt: item?.createdAt || "",
            updatedAt: item?.updatedAt || "",
          })
        );
        setuserlist(RowsData);
        setTotalCount(response?.exportFilteredScreenings?.totalCount || 0);
      } else {
        setuserlist([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsFilter(true);
    }
  };

  const exportClose = () => {
    setOpenExport(false);
  };

  const isButtonValid =
    filterState?.interviewFromDateStatus === "success" &&
    filterState?.interviewToDateStatus === "success";

  return (
    <DashboardLayout
      searchdata={searchdata}
      setsearchdata={setsearchdata}
      setOpenFilter={setOpenFilter}
      setOpenExport={setOpenExport}
      name={sortedData.length > 0 ? "Interviewed" : ""}
    >
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      {Loader && <LoadingSpinner />}
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <ExportDialog
        open={openExport}
        onClose={exportClose}
        setPopup={setPopup}
        data={exportData}
        fileName="Interview"
        exportStatus="interview"
        isFilter={isFilter}
        fileterdownloadurl={fileterdownloadurl}
      />
      <ReusableFilter
        data={filterState}
        dispatch={dispatch}
        open={openFilter}
        dateFalse={false}
        isButtonValid={isButtonValid}
        onClose={filterClose}
        onSave={() => {
          setIsFilter(true);
          if (page === 1) {
            filterSubmit();
          } else {
            setPage(1);
          }
          filterClose();
        }}
        title="Interview Filter"
      >
        {/* interviewFromDate */}
        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            interview From Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="interviewFromDate"
            value={filterState?.interviewFromDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.interviewFromDateStatus === "error"}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />
        </Grid>

        {/* interviewToDate */}
        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            interview To Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="interviewToDate"
            value={filterState?.interviewToDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.interviewToDateStatus === "error"}
            inputProps={{
              min: filterState?.interviewFromDate || undefined,
            }}
          />
        </Grid>

        {/* onboardJoiningFromDate
        <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            onboardJoiningFromDate <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="fromDate"
            value={filterState?.fromDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.fromDateStatus === "error"}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />
        </Grid> */}

        {/* onboardJoiningToDate */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            onboard Joining To Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="toDate"
            value={filterState?.toDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.toDateStatus === "error"}
            inputProps={{
              min: filterState?.fromDate || undefined,
              max: new Date().toISOString().split("T")[0],
            }}
          />
        </Grid> */}

        {/* onboardSrFromDate */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            onboardSrFromDate <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="fromDate"
            value={filterState?.fromDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.fromDateStatus === "error"}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />
        </Grid> */}

        {/* onboardSrToDate */}
        {/* <Grid size={{ xs: 12, md: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            onboardSrToDate <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            fullWidth
            type="date"
            name="toDate"
            value={filterState?.toDate || ""}
            onChange={(e) => handleChangeDispatch(e, dispatch)}
            error={filterState?.toDateStatus === "error"}
            inputProps={{
              min: filterState?.fromDate || undefined,
              max: new Date().toISOString().split("T")[0],
            }}
          />
        </Grid>
 */}

        {/* 👇 Client Autocomplete */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Client
          </MaterialTypography>
          <Autocomplete
            multiple
            options={clientOptions || []}
            getOptionLabel={(option) => option.label || ""}
            value={filterState?.client || []}
            onChange={(event, newValue) =>
              dispatch({ name: "client", value: newValue })
            }
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              (selected || []).map((option, index) => (
                <Chip
                  key={index}
                  label={option.label}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Client(s)" />
            )}
          />
        </Grid>

        {/* 👇 User Autocomplete */}
        {(user?.roleName === "Admin" ||
          user?.roleName === "Team Lead" ||
          user?.roleName === "Team Leader") && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                User
              </MaterialTypography>
              <Autocomplete
                multiple
                options={userOptions || []}
                getOptionLabel={(option) => option.label || ""}
                value={filterState?.user || []}
                onChange={(event, newValue) =>
                  dispatch({ name: "user", value: newValue })
                }
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  (selected || []).map((option, index) => (
                    <Chip
                      key={index}
                      label={option.label}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select User(s)" />
                )}
              />
            </Grid>
          )}
      </ReusableFilter>
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        {isFilter && (
          <Tooltip title="Reset Filter" placement="top">
            <IconButton
              onClick={handleResetFilter}
              sx={{ fontSize: "25px", background: colors.buttonColor, mr: 1 }}
            >
              <RestartAltIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        )}
        <Dialog
          open={open}
          sx={{
            "& .MuiDialog-paper": {
              width: "800px", // Set your desired width
              maxWidth: "none", // Prevent it from limiting the width to default sizes
            },
          }}
        >
          <AddInterview
            formClose={formClose}
            editeddata={editeddata}
            editedtrue={editedtrue}
            setEditedtrue={setEditedtrue}
            view={view}
            isview={isview}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={deletelist}
        name="Interviewed"
        serverPage={page}
        totalCount={totalCount}
        rowsPerPage={pageSize}
        onPageChange={(event, newPage) => setPage(newPage)}
        ischeck={false}
      />
    </DashboardLayout>
  );
}

export default Interview;
